// extracted by mini-css-extract-plugin
module.exports = {"root":"StatsSharing_root__36Fm8","preview-content":"StatsSharing_preview-content__27Wfu"};